import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=61205562&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61205562",
  null
  
)

export default component.exports